module.exports = __webpack_public_path__ + "img/128.6eb1a325.png";